<template>
<div class="py-12 px-4">
      <nav class="mb-2 flex flex-wrap justify-between">
      </nav>
       <div class="mb-5 flex flex-col lg:flex-row">
          <div
            class="box shadow-md flex flex-col justify-center items-center py-4 px-8 lg:w-max w-full"
          >
        <label for="family-head-idcard-input" class="form-label text-theme-98">เลขบัตรประจำตัวประชาชน <span class="text-theme-5">*</span></label>
                        <input 
                          id="family-head-idcard-input" 
                          type="text" 
                          class="form-control placeholder-theme-19"
                          placeholder="กรุณากรอกเลขบัตรประชาชน" 
                          data-test="family-head-idcard"
                          maxlength="13"
                          v-model="state.idCardNumber"  
                          @input="onlyNumber"/>
                        <div class="xs:col-span-2 md:col-span-2 pt-7">
                      <button 
                        type="button" 
                        class="btn btn-primary w-15 font-medium" 
                        data-test="submit-add-family-button"
                        @click="checkHouseholdHead">
                          ค้นหา
                      </button>
                    </div>
        </div>
    </div>
    <div class="mb-5 flex flex-col lg:flex-row">
          <div
            class="box shadow-md flex flex-col justify-center items-center py-4 px-8 lg:w-max w-full"
          >
          {{csg_data}}
          </div>
    </div>
</div>
</template>

<script setup>
import { shallowRef, ref, onMounted, computed, watch, reactive, provide } from "vue";
import axios from "axios";
import { Buffer } from 'buffer';

const csg_data = ref(null);
const state = reactive({
  idCardNumber: '1149901588313'
})
const decode = async (string) => {
  return Buffer.from(string, 'base64').toString('utf8');
}
const checkHouseholdHead = async() => {
       const config = {url: `https://mso-logbook.m-society.go.th/api/dc/csg/v1?queryCode=MSO&EQC_IDCARD=${state.idCardNumber}`,
                    method: "GET",
                    headers:{
                        Authorization: `Bearer -69dn6ubuq7ln5q6qj0gjsgfcdgvw7yyzwubwa76sc1nol61oq`
                    }
                }
                await axios(config)
                .then((res)=>{
                  console.log(res.data.rows[0])
                  csg_data.value = res.data.rows[0]
                }).catch((error)=>{console.log(error)})
}
const onlyNumber = () => {
  state.idCardNumber = state.idCardNumber.replace(/[^\d]/g, "")
  if(state.idCardNumber.length !== 13){
    sumId.value = null
    getDataFromApi.value = null
    showHouseheadLayout.value = false
    // clearValue()
  } 
}
</script>